import { render, staticRenderFns } from "./ProcessingHistory.vue?vue&type=template&id=38b2673a&scoped=true"
import script from "./ProcessingHistory.vue?vue&type=script&lang=js"
export * from "./ProcessingHistory.vue?vue&type=script&lang=js"
import style0 from "./ProcessingHistory.vue?vue&type=style&index=0&id=38b2673a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2673a",
  null
  
)

export default component.exports